export default __webpack_public_path__ + "static/media/outsourced_transportation_service.1a3d8b6c.jpg";